import React, { Suspense, useEffect, useRef } from "react";
import { useRoutes, useNavigate, useLocation } from "react-router-dom";
import routers from "./router";
import {
  clearToken,
  getTokenToLocalStorage,
  setTokenToLocalStorage,
} from "./utils/token";
import { Helmet, HelmetProvider } from "react-helmet-async";
import LoadingDom from "./components/UI/LoadingDom";
import { getUserPermissions } from "./components/business/RolePermission";
import { Permissions } from "./components/business/RolePermission/permissions";
import { Message } from "@arco-design/web-react";
import { coming_soon_icon } from "./assets/user-center";
import loginStore from "./stores/login";
import appStore from "./stores/appStore";
import { refresh_token } from "./services/login";
import LoadingGIF from "./components/UI/LoadingGIF";
import "animate.css";
import "@/style/font-awesome/css/font-awesome.css";
import BreadStore from "./stores/spaceStore/breadcrumbStore";

function App() {
  const element = useRoutes(routers);
  const location = useLocation();
  const routerPermissions = [
    {
      path: "/",
      exempt: true,
    },
    {
      path: "/data-dashboard",
      exempt: true,
    },
    {
      title: "登录",
      path: "/login",
      exempt: true,
    },
    {
      title: "工作台",
      path: "/work-bench",
      exempt: true,
    },
    {
      title: "创作空间",
      path: "/creative-space",
      permissions: Permissions.CreativeSpace,
    },
    {
      subTitle: "爆款脚本",
      path: "/creative-script",
      permissions: Permissions.HotScript,
    },
    {
      subTitle: "创建脚本",
      path: "/creation-script",
      exempt: true,
    },
    {
      subTitle: "AI主题创作",
      path: "/ai-creation",
      permissions: Permissions.AIThemeCreation,
    },
    {
      subTitle: "AI视频解析",
      path: "/analysis-video",
      permissions: Permissions.AIVideoAnalysis,
    },
    {
      subTitle: "智能魔剪",
      path: "/video-clips",
      permissions: Permissions.IntelligentEditing,
    },
    {
      subTitle: "一键成片",
      path: "/accomplish",
      nothingness: true,
    },
    {
      subTitle: "图文创作",
      path: "/graphicediting",
      nothingness: true,
    },
    {
      subTitle: "团队概览",
      path: "/team-overview",
      permissions: Permissions.TeamManagement,
    },
    {
      subTitle: "团队成员",
      path: "/team-anagement",
      permissions: Permissions.TeamManagement,
    },

    // {
    //   title: "矩阵营销",
    //   path: `/matrix`,
    //   permissions: Permissions.MatrixMarketing,
    //   // nothingness: true,
    // },
    {
      title: "任务中心",
      path: "/task-center",
      permissions: Permissions.TaskCenter,
    },
    {
      title: "个人中心",
      path: "/user",
      permissions: Permissions.UserCenter,
    },
    {
      path: "/ai-creation",
      exempt: true,
    },
    {
      path: "/creative-space/recycling-station",
      exempt: true,
    },
    {
      path: "/aithemecreationtable",
      exempt: true,
    },
    {
      path: "/aithemescriptcreate",
      exempt: true,
    },
    {
      path: "/creation-script/:id",
      exempt: true,
    },
    {
      path: "/team-anagement",
      exempt: true,
    },
    {
      path: "/team-overview",
      exempt: true,
    },
    {
      path: "/analysis-video",
      exempt: true,
    },
    {
      path: "/analysis-video/:id",
      exempt: true,
    },
    {
      path: "/mix-detail/:id/:script_id",
      exempt: true,
    },
    {
      path: "/image-text",
      exempt: true,
    },
    {
      path: "/mixcutDetail/:id",
      exempt: true,
    },
    {
      path: "/video-clip-result/:projectId/:count",
      exempt: true,
    },
    {
      path: "/invite",
      exempt: true,
    },
    {
      path: "/video-editing",
      exempt: true,
    },
    {
      path: "/agreement:type",
      exempt: true,
    }
  ];
  const navigate = useNavigate();
  const isRouter = () => {
    return routerPermissions.find((v) => {
      const regex = new RegExp(`^${v.path.replace(/:\w+/g, "\\w+")}$`, "i");
      return regex.test(location.pathname);
    });
  };

  const ifameMsg = async (e) => {
    // console.log("iframe", e);

    if (e.data.type === "init") {
      const token = e.data.data.token;
      console.log("token", token);

      if (token) {
        await loginStore.login_by_token({ access_token: token });
        navigate("/work-bench", { replace: true });
      }
    }

    if (e.data.type === "refresh_token") {
      const token = e.data.data.token;
      refresh_token({ refresh_token: token });
    }
  };

  useEffect(() => {
    console.log("appStore.isInFrame", appStore.isInFrame);
    appStore.getConfig();

    if (appStore.isInFrame) {
      // window.parent.postMessage(
      //   {
      //     type: "init",
      //     data: "iframe loaded",
      //   },
      //   "*"
      // );

      if (window.qf_token) {
        const token = window.qf_token;
        loginStore
          .login_by_token({
            access_token: token,
          })
          .then(() => {
            navigate("/work-bench", { replace: true });
          });
      }

      console.log("window.addEventListener ===================");
      window.addEventListener("message", ifameMsg, false);
    }
    return () => {
      window.removeEventListener("message", ifameMsg, false);
    };
  }, []);

  useEffect(() => {
    const path = location.pathname;
    const queryParams = new URLSearchParams(location.search);
    const isNext = queryParams.get("next");

    // 清除面包屑
    BreadStore.clearBreadList();
    // 检查是否需要登录
    if (path.includes('/agreement')) {
      navigate(path);
    } else {
      if (!getTokenToLocalStorage()) {
        const currentRoute = isRouter();
        console.log("currentRoute", currentRoute);

        // 如果当前路由需要权限且没有token，则跳转到登录页
        if (currentRoute && !currentRoute.exempt) {
          const next = path + location.search;
          navigate(`/login?next=${encodeURIComponent(next)}`);
          return;
        }
      }
    }

  }, [navigate]);
  return (
    <HelmetProvider>
      <>
        <Helmet></Helmet>
        <React.Fragment>
          <Suspense
            fallback={
              !appStore.isOdm ? (
                <LoadingDom isLoading>
                  <div style={{ width: "100vw", height: "100vh" }}></div>
                </LoadingDom>
              ) : (
                <div
                  style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LoadingGIF />
                </div>
              )
            }
          >
            {element}
          </Suspense>
        </React.Fragment>
      </>
    </HelmetProvider>
  );
}

export default App;
